import functions from "./lib/functions.js";

import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import VueGtag from "vue-gtag";
import LoadScript from "vue-plugin-load-script";

Vue.use(Vuex);
Vue.use(VueGtag, {
  bootstrap: false
});
Vue.use(LoadScript);
Vue.config.productionTip = false;

const store = new Vuex.Store({
  state: {
    uniqueID: "",
    uniqueIDType: "event",
    cur_lang: null,
    def_lang: null,
    title: "",
    contentBasePath: "",
    userData: null,
    analytics: [],
    isRestart: false,
    videodebug: false,
    poster: null,
    ip: null,
    player: {
      disableLegacyBrowsers: false,
      autoplay: false,
      loop: false,
      debug: false,
      lowLatency: false,
    },
    rendition: null,
    streamOutputs: [],
    streamCurOutput: null,
    previewToken: null,
    vodOutputs: [],
    vodCurOutput: null,
    iwcache: {
      domain_name: "",
      iwcache_network_id: "",
      active: false, //player dentro dominio iwcache
      entrypoint_id: "",
    },
    stream: {
      liveURL: "",
      overrideURL: "",
      lowLatency: false,
    },
    videoJSOptions: {
      autoplay: true,
      controls: true,
      muted: true,
      fill: false, //Fill mode will make the player fit and fill out its container. This is often useful if you have a responsive website and already have a container for Video.js that resizes properly to your design. It can be set either via a class or an option.
      fluid: false, //Video.js has a fluid mode that keeps the player sized to a particular aspect ratio. By default, fluid mode will use the intrinsic size of the video once loaded but you can change it with classes or with the aspectRatio option.
      //aspectRatio: null, //16:9 | 1:1 | ....
      loop: true,
      sources: [
        {
          src: "",
          type: "application/x-mpegURL",
        },
      ],
      //textTrackSettings: false,
      nativeControlsForTouch: true,
      html5: {
        nativeTextTracks: true,
        vhs: {
          overrideNative: true,
          useDtsForTimestampOffset: true,
        },
        hlsjsConfig: {},
      },
      controlBar: {
        pictureInPictureToggle: false,
      },
      audioOnlyMode: false,
      errorDisplay: false,
    },
    p2p: {
      config: {
        p2p: false,
        p2ptech: "",
        p2pip: "",
        p2pgroup: "",
      },
      p2pmedialoader: {
        segments: {
          swarmId: "",
        },
        loader: {
          trackerAnnounce: process.env.VUE_APP_P2PML_TRACKER,
        },
      },
    },
    q: 0,
    cuePoints: null,
    cuePoint: {
      asset_id: "",
      cur_comments_active: "",
      cur_poll_id: "",
      cur_questions_active: "",

      event_id: "",
      field1: "",
      field2: "",
      field3: "",
      field4: "",
      field5: "",
      layout_mode: "",
      fullscreen: false,
      mode: "",
      q: "",
      slide: "",
      slideset: "",
      status_id: "",
      status_title: "",
      text: "",
      status: "live",
      uts: 0,
    },
    isPlayerPlaying: false,
    disable_check_cuepoints: false,
    active: false,
    auto_resize: false,
    skin: null,
  },
  mutations: {
    setUniqueID(state, value) {
      Vue.set(state, "uniqueID", value);
    },
    setUniqueIDType(state, value) {
      Vue.set(state, "uniqueIDType", value);
    },
    set_cur_lang(state, value) {
      Vue.set(state, "cur_lang", value);
    },
    set_def_lang(state, value) {
      Vue.set(state, "def_lang", value);
    },
    setTitle(state, value) {
      document.title = value;

      Vue.set(state, "title", value);
    },
    setContentBasePath(state, value) {
      Vue.set(state, "contentBasePath", value);
    },
    setUserData(state, value) {
      Vue.set(state, "userData", value);
    },
    setAnalytics(state, analytics) {
      Vue.set(state, "analytics", analytics);
    },
    setVideodebug(state, value) {
      Vue.set(state, "videodebug", value);
    },
    setPlayerParameters(state, playerParameters) {
      Vue.set(
        state.player,
        "disableDegacyBrowsers",
        playerParameters.disableLegacyBrowsers
      );
      Vue.set(state.player, "autoplay", playerParameters.autoplay);
      Vue.set(state.player, "loop", playerParameters.loop);
      Vue.set(state.player, "debug", playerParameters.debug);
      if (playerParameters.lowLatency) {
        Vue.set(state.lowLatency, "lowLatency", playerParameters.lowLatency);
      }
    },
    setRendition(state, arg_value) {
      Vue.set(state, "rendition", arg_value);
    },
    setStreamOutputs(state, arg_outputs = null) {
      try {
        if (!arg_outputs) {
          arg_outputs = state.streamOutputs;
        }
        Vue.set(state, "streamOutputs", arg_outputs);
        let streamCurOutputIndex = functions.calculateLangUrl(
          arg_outputs,
          state.cur_lang,
          state.def_lang,
          null
        );
        let streamCurOutput = null;
        if (streamCurOutputIndex !== null) {
          streamCurOutput = arg_outputs[streamCurOutputIndex].url;
          if (state.rendition && state.rendition != "master") {
            if (state.p2p?.config?.p2pgroup != null) {
              streamCurOutput = streamCurOutput.replace(
                "master",
                state.rendition
              );
            } else {
              streamCurOutput = streamCurOutput.replace(
                "master",
                "master_" + state.rendition
              );
            }
          }
          Vue.set(
            state.iwcache,
            "entrypoint_id",
            arg_outputs[streamCurOutputIndex].entrypoint_id
          );
        } else {
          // If it's live I have p2p otherwise if there is no entrypoint id I have no possibility of p2p
        }
        this.commit("setStreamCurOutput", streamCurOutput);
      } catch (err) {
        console.log(err);
      }
    },
    setStreamCurOutput(state, arg_curOutput) {
      Vue.set(state, "streamCurOutput", arg_curOutput);
    },
    setPreviewToken(state, value) {
      Vue.set(state, "previewToken", value);
    },
    setIsPlayerPlaying(state, value) {
      Vue.set(state, "isPlayerPlaying", value);
    },

    setVodOutputs(state, arg_outputs = null) {
      try {
        if (!arg_outputs) {
          arg_outputs = state.vodOutputs;
        }
        Vue.set(state, "vodOutputs", arg_outputs);
        let vodCurOutputIndex = functions.calculateLangUrl(
          arg_outputs,
          state.cur_lang,
          state.def_lang
        );
        if (
          state.iwcache?.active &&
          arg_outputs[vodCurOutputIndex]?.url != null
        ) {
          arg_outputs[vodCurOutputIndex].url = arg_outputs[
            vodCurOutputIndex
            ].url.replace(process.env.VUE_APP_IWCAST_VOD_HOST, "/vod");
        }
        let vodCurOutput = null;
        if (vodCurOutputIndex !== null) {
          vodCurOutput = arg_outputs[vodCurOutputIndex]?.url;
        }
        this.commit("setVodCurOutput", vodCurOutput);
      } catch (err) {
        console.log(err);
      }
    },
    setVodCurOutput(state, arg_curOutput) {
      Vue.set(state, "vodCurOutput", arg_curOutput);
    },
    setIwcacheActive(state, status) {
      Vue.set(state.iwcache, "active", status);
    },
    setIwcache(state, iwcache) {
      Vue.set(state.iwcache, "domain_name", iwcache.domain_name);
      Vue.set(state.iwcache, "iwcache_network_id", iwcache.iwcache_network_id);
      Vue.set(
        state.iwcache,
        "iwcache_network_only",
        iwcache.iwcache_network_only
      );
    },
    setStream(state, stream) {
      Vue.set(state.stream, "liveURL", stream.liveURL);
      Vue.set(state.stream, "overrideURL", stream.overrideURL);
      Vue.set(state.stream, "lowLatency", stream.lowLatency);
    },

    setVideoJSOptions(state, videoJS) {
      if (videoJS.autoplay) {
        Vue.set(state.videoJSOptions, "autoplay", true);
        Vue.set(state.videoJSOptions, "muted", true);
      } else {
        Vue.set(state.videoJSOptions, "autoplay", false);
        Vue.set(state.videoJSOptions, "muted", false);
      }
      if (videoJS.loop) {
        Vue.set(state.videoJSOptions, "loop", videoJS.loop);
      } else {
        Vue.set(state.videoJSOptions, "loop", false);
      }

      Vue.set(state.videoJSOptions.sources[0], "src", videoJS.src);
      Vue.set(state.videoJSOptions.sources[0], "type", videoJS.type);
    },
    setVideoJSOptions_audio_only_mode(state, value) {
      Vue.set(state.videoJSOptions, "audioOnlyMode", value);
    },
    setVideoJSOptions_nativeControlsForTouch(state, value) {
      Vue.set(state.videoJSOptions, "nativeControlsForTouch", value);
    },
    setLocalIP(state, ip) {
      Vue.set(state, "ip", ip);
    },
    setP2PConfig(state, p2p) {
      Vue.set(state.p2p, "config", p2p);
    },
    setP2PMediaLoader(state, swarmID) {
      Vue.set(state.p2p.p2pmedialoader.segments, "swarmId", swarmID);
    },
    setStatusCuepoint(state, statusCuepoint) {
      Vue.set(state, "statusCuepoint", statusCuepoint);
    },
    setCuePoints(state, cuePoints) {
      Vue.set(state, "cuePoints", cuePoints);
      window.parent.postMessage(
        {type: "cuePoints", content: {cuePoints: cuePoints}},
        "*"
      );
    },
    setCuePoint(state, cuePoint) {
      if (state.cuePoint.layout_mode != cuePoint.layout_mode) {
        Vue.set(state, "isPlayerPlaying", false);
      }

      Vue.set(state, "cuePoint", cuePoint);

      //this.commit("setStreamOutputs", cuePoint.outputs);
      this.commit("setVodOutputs", cuePoint.videos);
      if (cuePoint.status === "live") {
        if (cuePoint.live_outputs) {
          this.commit("setStreamOutputs", cuePoint.live_outputs);
        }
      } else {
        this.commit("setStreamOutputs", []);
      }
      try {
        window.parent.postMessage(
          {type: "cuePoint", content: {state: null, cuePoint: cuePoint}},
          "*"
        );
      } catch (e) {
        //console.error(e);
      }
    },
    set_disable_check_cuepoints(state, value) {
      Vue.set(state, "disable_check_cuepoints", value);
    },
    setActive(state, value) {
      Vue.set(state, "active", value);
    },
    setPoster(state, value) {
      Vue.set(state, "poster", value);
    },
    setAuto_resize(state, value) {
      Vue.set(state, "auto_resize", value);
    },
    setSkin(state, value) {
      Vue.set(state, "skin", value);
    },
    setIsRestart(state, value) {
      Vue.set(state, "isRestart", value);
    },
  },
  getters: {
    getUniqueID: (state) => state.uniqueID,
    getUniqueIDType: (state) => state.uniqueIDType,
    getCur_lang: (state) => state.cur_lang,
    getDef_lang: (state) => state.def_lang,
    getTitle: (state) => state.title,
    getContentBasePath: (state) => state.contentBasePath,
    getUserData: (state) => state.userData,
    getAnalytics: (state) => state.analytics,
    getIsRestart: (state) => state.isRestart,
    getAnalyticsItemByKind: (state) => (kind) => {
      if (!state.analytics || state.analytics.length == 0) {
        return null;
      } else {
        var analyticsByKind = state.analytics.filter((obj) => {
          return obj.kind == kind;
        });
        if (analyticsByKind.length > 0) {
          return analyticsByKind[0];
        } else {
          null;
        }
      }
    },
    getVideodebug: (state) => state.videodebug,
    getPlayerParameters: (state) => state.player,
    getRendition: (state) => state.rendition,
    getStreamOutputs: (state) => state.streamOutputs,
    getStreamCurOutput: (state) => state.streamCurOutput,
    getPreviewToken: (state) => state.previewToken,
    getVodOutputs: (state) => state.vodOutputs,
    getVodCurOutput: (state) => state.vodCurOutput,
    getIwcacheActive: (state) => state.iwcache?.active,
    getIwcache: (state) => state.iwcache,
    getStream: (state) => state.stream,
    getIp: (state) => state.ip,
    getStatus: (state) => state.cuePoint.status,
    getPoster: (state) => {
      return state.videoJSOptions.audioOnlyMode ? null : state.poster;
    },
    getVideoJSOptions: (state) => state.videoJSOptions,

    getP2PConfig: (state) => state.p2p.config,
    getP2PMediaLoader: (state) => state.p2p.p2pmedialoader,

    getStatusCuepoint: (state) => state.statusCuepoint,
    getCuePoints: (state) => {
      return state.cuePoints;
    },
    getCuePoint: (state) => {
      return state.cuePoint;
    },
    getIsPlayerPlaying: (state) => {
      return state.isPlayerPlaying;
    },
    get_disable_check_cuepoints: (state) => state.disable_check_cuepoints,
    getActive: (state) => state.active,
    getAuto_resize: (state) => state.auto_resize,
    getSkin: (state) => state.skin,
    getVideoJSOptions_audio_only_mode: (state) =>
      state.videoJSOptions.audioOnlyMode,
  },
  actions: {},
});

new Vue({
  store: store,
  render: h => h(App)
}).$mount("#app");
